import { render, staticRenderFns } from "./RequestsScreen.vue?vue&type=template&id=ff70b69a"
import script from "./RequestsScreen.vue?vue&type=script&lang=js"
export * from "./RequestsScreen.vue?vue&type=script&lang=js"
import style0 from "./RequestsScreen.vue?vue&type=style&index=0&id=ff70b69a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports